import { makeStyles } from "tss-react/mui";

/**
 * Must match the video's aspect ratio exactly.
 */
const videoDimensions = {
  width: 1366,
  height: 572,
};
const paddingBottom = `${
  (videoDimensions.height / videoDimensions.width) * 100
}%`;

export const useNWONTeamVideoStyles = makeStyles()((theme) => ({
  skeletonAndVideo: {
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
  },
  videoEmbedContainer: {
    position: "relative",
    paddingBottom,
    height: 0,
    overflow: "hidden",
    width: "100%",
    maxWidth: "100%",
    marginBottom: theme.spacing(15 / 2),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(10 / 2),
    },
  },
  headlineSection: {
    "& .MuiContainer-root": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
    marginTop: theme.spacing(10),
    [theme.breakpoints.down("lg")]: {
      marginTop: theme.spacing(6),
    },
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(3),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(0.5),
    },
  },
  h1: { color: theme.palette.common.white },
}));
